/*
  DEPRECATED VERSION - DO NOT USE - Works with Algolia products
 */
/* Don't forget to update product-tile.liquid! */
const productTileTemplate = () => {
  // return `<% console.log(products[index]) %>`;
  const placeholder = window.theme.collections.placeholder;

  return `
    <% // console.log(products[index]); %>
    <%
    if (typeof products[index].variants === 'undefined' || products[index].variants.length === 0) {
      return;
    }

    var product = products[index];

    // Some tiles don't have Algolia data (lookbooks...)
    var has_algolia_data = (typeof product.algolia !== 'undefined');

    // Simplified tiles don't have the wishlist, flags
    var simplified_tile = (typeof is_simplified !== 'undefined' && is_simplified === true);

    // Lookbook tiles use a different grid layout
    var lookbook_tile = (typeof is_lookbook !== 'undefined' && is_lookbook === true);

    // Quickview
    var is_quickview = (typeof quickview !== 'undefined' && quickview === true);

    // Plus Size
    var is_plus_size = has_algolia_data ? (product.algolia.option1.includes('Plus Size -')) : false;

    // Inject the Algolia product ID to the product URL
    var product_url = product.url;
    if (has_algolia_data) {
      product_url += (product_url.indexOf('?') === -1) ? '?' : '&';
      product_url += 'apid=' + product.algolia.objectID;
    }

    // We don't load the tags from StorefrontAPI if Algolia data is available
    var product_tags = (typeof product.tags === 'undefined' || product.tags === null) ? [] : product.tags;
    if (has_algolia_data && typeof product.algolia.tags !== 'undefined') {
      product_tags = product.algolia.tags;
    }

    // We don't load the associated collections from StorefrontAPI if Algolia data is available
    var product_collections = (typeof product.collections === 'undefined' || product.collections === null) ? [] : product.collections;
    if (has_algolia_data && typeof product.algolia.collections !== 'undefined') {
      product_collections = product.algolia.collections;
    }

    // Different promo message for logged-in/loyalty and guest customers

    // Promo applied by product tag or collection. Ignored when a promotion call out message has been defined for all products
    var promo_message = window.theme.promoMessage.guests;
    var promo_message_color = window.theme.promoMessage.color;
    var promo_discount = window.theme.promoMessage.guestPercentOff;
    var promo_discount_color = window.theme.promoMessage.colorPercentOff;
    var promo_tag = window.theme.promoMessage.tag;
    var promo_collection = window.theme.promoMessage.collection;
    var special_message = '';

    // Promo applied to all products.
    if (window.theme.promoMessage.guestsAllProducts !== '') {
      promo_message = window.theme.promoMessage.guestsAllProducts;
      promo_message_color = window.theme.promoMessage.colorAllProducts;
    }
    if (window.theme.promoMessage.guestAllProductsPercentOff !== 0) {
      promo_discount = window.theme.promoMessage.guestAllProductsPercentOff;
      promo_discount_color = window.theme.promoMessage.colorAllProductsPercentOff;
    }
    if (window.theme.promoMessage.guestsAllProducts !== '' || window.theme.promoMessage.guestAllProductsPercentOff !== 0) {
      promo_tag = '';
      promo_collection = '';
    }

    // Promo applied to loyalty members
    if (typeof window.theme.customer.id !== 'undefined') {
      promo_message = window.theme.promoMessage.loyalty;
      promo_discount = window.theme.promoMessage.loyaltyPercentOff;
      promo_discount_color = window.theme.promoMessage.colorPercentOff;

      // Promo applied to all products.
      if (window.theme.promoMessage.loyaltyAllProducts !== '') {
        promo_message = window.theme.promoMessage.loyaltyAllProducts;
        promo_message_color = window.theme.promoMessage.colorAllProducts;
      }
      if (window.theme.promoMessage.loyaltyAllProductsPercentOff !== 0) {
        promo_discount = window.theme.promoMessage.loyaltyAllProductsPercentOff;
        promo_discount_color = window.theme.promoMessage.colorAllProductsPercentOff;
      }
      if (window.theme.promoMessage.loyaltyAllProducts !== '' || window.theme.promoMessage.loyaltyAllProductsPercentOff !== 0) {
        promo_tag = '';
        promo_collection = '';
      }
    }

    // Special message
    if (window.theme.promoMessage.specialMessage !== '') {
      if (typeof window.theme.customer.id === 'undefined') {
        if (window.theme.promoMessage.specialMessageCustomers === 'guests' || window.theme.promoMessage.specialMessageCustomers === 'all') {
          special_message = window.theme.promoMessage.specialMessage;
        }
      } else {
        if (window.theme.promoMessage.specialMessageCustomers === 'members' || window.theme.promoMessage.specialMessageCustomers === 'all') {
          special_message = window.theme.promoMessage.specialMessage;
        }
      }
    }
    %>
    <div class="product-tile<% if (product.slider === true) { %> swiper-slide<% } %><% if (lookbook_tile === false && product.slider !== true) { %> column-xs-6 column-sm-3<% } %> animate animate--fadeInUp"
      data-product-tile
      data-product-url="https://<%= window.location.host %><%= window.Shopify.routes.root.slice(0, -1) %><%= product_url %>"
      data-product-handle="<%= product.handle %>"
      data-product-id="<%= product.id %>"
      data-product-available="<%= product.available %>"
      data-first-variant-id="<%= product.variants[0].id %>"
      data-empi="<% if (typeof product.variants !== 'undefined' && product.variants.length > 0) { %><%= product.variants[0].id %><% } %>"
      <% if (typeof product.fs !== 'undefined') { %>data-product-fs-id="<%= product.fs.id %>"<% } %>
      <% if (has_algolia_data) { %>data-product-algolia-id="<%= product.algolia.objectID %>"<% } %>
      data-quickview="<%= is_quickview %>"
      data-plus-size="<%= is_plus_size %>"
      tabindex="0"
      aria-label="<%= product.title %>"
    >
      <% if (typeof product.variants !== 'undefined' && simplified_tile !== true) { %>
        <% if (typeof window.theme.customer.id === 'undefined') { %>
          <button type="button" class="swym-button swym-add-to-wishlist-view-product product_<%= product.id %> swym-heart swym-loaded" data-product-swym-wishlist data-product-handle="<%= product.handle %>" data-open-signin-actions-modal="wishlist" aria-label="Add to Wishlist"></button>
        <% } else { %>
          <button data-with-epi="true" type="button" class="swym-button swym-add-to-wishlist-view-product product_<%= product.id %>" data-product-swym-wishlist data-swaction="addToWishlist" data-product-id="<%= product.id %>" data-variant-id="<%= product.variants[0].id %>" data-product-url="https://<%= window.location.host %><%= window.Shopify.routes.root.slice(0, -1) %><%= product.url %>" data-product-handle="<%= product.handle %>" aria-label="Add to Wishlist"></button>
        <% } %>
      <% } %>

      <div class="product-tile__image-container">
        <a class="product-tile__image" href="<%= window.Shopify.routes.root %><%= product_url %>" data-product-tile-image aria-label="<%= product.title %>">
          <div class="product-tile__image--placeholder"><img src="${placeholder}" alt="<%= product.title %>" width="300" height="460" /></div>
          <% if ((typeof product.swatches !== 'undefined' && product.swatches.length) || typeof product.featured_image === 'undefined') { %>
            <div class="product-tile__image--main" data-product-main-image><img loading="lazy" src="${placeholder}" alt="<%= product.title %>" width="300" height="460" /></div>
            <% if (window.theme.breakpoints.current !== 'mobile') { %>
              <div class="product-tile__image--alt" data-product-alt-image><img loading="lazy" src="${placeholder}" alt="<%= product.title %>" width="300" height="460" /></div>
            <% } %>
          <% } else { %>
            <div class="product-tile__image--main" data-product-main-image><img loading="lazy" src="<%= product.featured_image %>" width="<%= product.featured_image_width %>" alt="<%= product.title %>" onError="this.src = '${placeholder}';" /></div>
            <% if (window.theme.breakpoints.current !== 'mobile') { %>
              <div class="product-tile__image--alt" data-product-alt-image><img loading="lazy" src="<%= product.featured_image %>" width="<%= product.featured_image_width %>" alt="<%= product.title %>" onError="this.src = '${placeholder}';" /></div>
            <% } %>
          <% } %>

          <% /* %>
          <!--
          <div class="add-to-cart-alt add-to-cart-alt--desktop btn btn--primary<% if (!product.available) { %> unavailable<% } %>" data-add-to-cart-alt-button role="button" tabindex="0" aria-label="Show product options"><span><%= window.theme.strings.addToCart %></span></div>
          <div class="add-to-cart-alt add-to-cart-alt--mobile<% if (!product.available) { %> unavailable<% } %>" data-add-to-cart-alt-button><span><%= window.theme.strings.addToCart %></span></div>
          -->
          <% */ %>
          <%
          /*
            Flags based on tags.
            Limit 1 per tile.
            Priority: Best Seller app flag > Trending app flag > Style metafield flag > Tag-based flag
          */
          %>
          <% if (simplified_tile !== true) { %>
          <div class="product-tile__flags">
          <%
            // Flags based on metafields
            var has_flag = false;
            if (has_algolia_data && typeof product.algolia.meta !== 'undefined') {
              jq.each(product.algolia.meta, function(index, meta) {
                // We just want to show a flag on the first 30 bestsellers/Trending
    
                if (typeof meta.bestseller_style_30 !== 'undefined' && parseInt(meta.bestseller_style_30) <= 30) {
                  %>
                  <div class="product-tile__flag product-tile__flag--app">Best Seller</div>
                  <%
    
                  has_flag = true;
                  return false;
                }
    
                if (typeof meta.bestseller_style_14 !== 'undefined' && parseInt(meta.bestseller_style_14) <= 30) {
                  %>
                  <div class="product-tile__flag product-tile__flag--app">Trending</div>
                  <%
    
                  has_flag = true;
                  return false;
                }
              });
            }
    
            if (has_flag === false) {
              for (let t = 0; t < product_tags.length; t++) {
                var tag = product_tags[t];
                if (tag.indexOf('flag:') !== -1) {
                  // We don't show the final sale tags anymore, but they are needed to add a cart note
          %>
                  <div class="product-tile__flag<% if (tag.toLowerCase().includes('final sale')) {%> product-tile__flag--final<% } else { %> product-tile__flag--tag<% } %>"><%= tag.replace('flag:', '') %></div>
          <%
                  if (tag.toLowerCase().includes('final sale')) {
                    has_flag = false;
                    continue;
                  } else {
                    has_flag = true;
                    break;
                  }
                }
              }
            }
          %>
          </div>
          <% } %>
        </a>

        <% if (is_quickview) { %>
          <div class="quicklook__button btn btn--secondary hidden--mobile" data-quicklook-button data-modal="#quicklook-modal"><span><%= window.theme.strings.quickView %></span></div>
          <div class="quicklook__button--mobile" data-quicklook-button-mobile><span><%= window.theme.strings.quickView %></span></div>
        <% } %>
      </div>

      <div class="product-tile__bottom">
        <div class="product-tile__colors-rating">
          <% if (typeof product.swatches !== 'undefined' && product.swatches.length) { %>
            <div class="product-tile__colors" data-product-tile-colors><%= product.swatches %></div>
          <% } %>

          <% if (products[index]?.algolia?.meta?.stamped?.reviews_average) { %>
            <a href="https://<%= window.location.host %><%= window.Shopify.routes.root.slice(0, -1) %><%= product_url %>#stamped-main-widget" class="product-tile__rating" data-product-tile-rating>
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.6842 10.1897L10.5874 12.5454L9.55157 8.10544L13 5.11807L8.45894 4.73281L6.6842 0.545441L4.90946 4.73281L0.368408 5.11807L3.81683 8.10544L2.78104 12.5454L6.6842 10.1897Z" fill="black"/></svg>
              <span><%= Number(products[index]?.algolia?.meta?.stamped?.reviews_average).toFixed(1) %></span>
            </a>
          <% } %>
        </div>

        <p class="product-tile__title" data-product-tile-title>
          <a href="<%= window.Shopify.routes.root %><%= product_url %>"><%= product.title %></a>
        </p>

        <p class="product-tile__price price" data-product-tile-price>
          <% if (product.from === '') { %>
            <% if (parseFloat(product.raw_compare_at_price, 10) > parseFloat(product.raw_price, 10)) { %>
              <span class="visually-hidden">Regular price</span>
              <span class="price__sales"><%= product.price %></span>
              <s class="price__compare-at"><%= product.compare_at_price %></s>
            <% } else { %>
              <span class="price__regular"><%= product.price %></span>
            <% } %>
          <% } else { %>
            <span class="price__regular">From <%= product.from %></span>
          <% } %>

          <% if (!product.available) { %>
            <span class="price__sold-out">Sold Out</span>
          <% } %>
        </p>

        <%
        // Discount message
        let discount_message_html = '';

        if (promo_discount && promo_discount !== 0 && product.from === '') {
          discount_message_html = '<p class="product-tile__price-promo" data-product-tile-price-promo data-raw-price="' + product.raw_price + '" data-promo-discount="' + promo_discount + '"><span class="price__promo" style="color: ' + promo_discount_color + ' !important;">$' + String(parseFloat((parseFloat(product.raw_price, 10) - ((parseFloat(product.raw_price, 10) * promo_discount) / 100)) / 100).toFixed(2)) + ' after ' + promo_discount + '% off</span></p>';
        }

        // Special message, we need to make sure it only applies to the selected collection if any
        let special_message_html = '';
        if (special_message !== '') {
          var show_special_message = false;

          if (window.theme.promoMessage.specialMessageCollection === '') {
            show_special_message = true;
          } else {
            if (is_search === false) {
              if (window.theme.promoMessage.specialMessageCollection === jq('[data-collection-grid]').data('collection')) {
                show_special_message = true
              }
            }

            if (show_special_message === false) {
              for (let i = 0; i < product_collections.length; i++) {
                var collection = product_collections[i];

                if (collection === window.theme.promoMessage.specialMessageCollection) {
                  show_special_message = true;
                  break;
                }
              }
            }
          }

          if (show_special_message === true) {
            special_message_html = '<span class="product-tile__special-message" data-same-line="' + window.theme.promoMessage.specialMessageSameLine + '">' + special_message + '</span>';
          }
        }

        // Promo message
        let promo_message_html = '';
        if (promo_message !== '') {
          promo_message_html = '<p data-product-tile-message class="product-tile__message" style="color: ' + promo_message_color + ' !important;" tabindex="0"><span>' + promo_message + '</span>' + special_message_html + '</p>';
        }

        if (promo_tag === '' && promo_collection === '') {
          // Message for all products
        %>
          <%= discount_message_html %>
          <%= promo_message_html %>
        <%
          if (promo_message_html === '' && special_message_html !== '') { %>
            <p data-product-tile-message class="product-tile__message" style="color: <%= promo_message_color %> !important;" tabindex="0"><%= special_message_html %></p>
          <% }
        } else {
          // Message for specific tagged products or collections
          var show_promo_message = false;

          if (promo_tag !== '' && promo_collection === '') {
            for (let i = 0; i < product_tags.length; i++) {
              var tag = product_tags[i];
              if (tag.indexOf(promo_tag) !== -1) {
                show_promo_message = true;
                break;
              }
            }
          } else {
            if (is_search === false) {
              if (promo_collection === jq('[data-collection-grid]').data('collection')) {
                show_promo_message = true;
              }
            }

            if (show_promo_message === false) {
              for (let i = 0; i < product_collections.length; i++) {
                var collection = product_collections[i];

                if (collection === promo_collection) {
                  show_promo_message = true;
                  break;
                }
              }
            }
          }
          
          if (show_promo_message === true) { %>
            <%= discount_message_html %>
            <%= promo_message_html %>
          <%
            if (promo_message_html === '' && special_message_html !== '') { %>
              <p data-product-tile-message class="product-tile__message" style="color: <%= promo_message_color %> !important;" tabindex="0"><%= special_message_html %></p>
            <% }
          } else {
            if (special_message_html !== '') { %>
              <p data-product-tile-message class="product-tile__message" style="color: <%= promo_message_color %> !important;" tabindex="0"><%= special_message_html %></p>
          <% }
          } %>
        <% } %>
      </div>
    </div>`;
};

export { productTileTemplate };
